export default "__VITE_ASSET__CLojp7uW__"